import "bootstrap-icons/font/bootstrap-icons.css";
import { IProfileStyles } from "../index";
import { ClaimHelper } from "../../utils/helpers/claimHelper";
import { useThemeMode } from "../../theme/ThemeProvider";
import { ProfileActionButton, ThemeToggleRow, ThemeToggleLabel, ThemeToggleSwitch } from "./profile.styled";

type ProfileProps = {
    style?: IProfileStyles;
    handleLogOutClick: Function;
    handleViewProfileClick: Function;
    handleChangePasswordClick: Function;
};

export const Profile = (props: ProfileProps) => {
    const displayName: string = ClaimHelper.getDisplayName();
    const email: string = ClaimHelper.getEmail();
    const initials: string = ClaimHelper.getUserInitials();
    const organizationName: string = ClaimHelper.getOrganizationName();
    const role: string = ClaimHelper.getRoleName();
    const { mode, toggleTheme } = useThemeMode();
    const isDarkMode = mode === "dark";

    const onLogOutClick = () => {
        props.handleLogOutClick();
    };

    const onViewProfileClick = () => {
        props.handleViewProfileClick();
    };

    const onChangePasswordClick = () => {
        props.handleChangePasswordClick();
    };

    return (
        <div className="d-flex align-items-start flex-column p-3" >
            <div className="container-fluid d-flex justify-content-between align-self-start flex-nowrap mt-1 mb-4 mx-1">
                <span className="me-auto" style={props.style?.profileText}>{organizationName}</span>
                <ProfileActionButton type="button" onClick={onLogOutClick}>
                    Sign out
                </ProfileActionButton>
            </div>
            <div className="container-fluid d-flex justify-content-between align-self-center flex-nowrap mx-1">
                <span style={props.style?.profileInitials} className="rounded-circle p-3 border me-5" >
                    {initials}
                </span>
                <div className="d-flex align-items-end flex-column">
                    <strong className="" style={props.style?.profileText}>{displayName}</strong>
                    <span className="mb-1" style={props.style?.profileText}>{email}</span>
                    <span className="mb-1" style={props.style?.profileText}>{role}</span>
                </div>
            </div>
            <div className="container-fluid mt-3 mx-1">
                <ThemeToggleRow>
                    <ThemeToggleLabel>
                        <i className={isDarkMode ? "bi bi-moon-stars" : "bi bi-sun"} aria-hidden="true" />
                        Dark mode
                    </ThemeToggleLabel>
                    <ThemeToggleSwitch
                        type="button"
                        role="switch"
                        aria-checked={isDarkMode}
                        aria-label="Toggle dark mode"
                        $checked={isDarkMode}
                        onClick={toggleTheme}
                    />
                </ThemeToggleRow>
            </div>
            <div className="container-fluid d-flex justify-content-between flex-nowrap mt-3 mx-1">
                <ProfileActionButton type="button" onClick={onViewProfileClick}>
                    View account
                </ProfileActionButton>
                <ProfileActionButton type="button" onClick={onChangePasswordClick}>
                    Change password
                </ProfileActionButton>
            </div>
        </div>
    );
};